// src/components/ThemeSwitcher.tsx
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useContent } from '../contexts/ContentContext';

const ThemeSwitcher: React.FC = () => {
    const { theme, toggleTheme } = useTheme();
    const { t } = useContent();

    return (
        <button
            onClick={toggleTheme}
            className="p-2 rounded-full text-gray-500 dark:text-gray-400 ivory:text-coffee-600 hover:bg-gray-100 dark:hover:bg-gray-700 ivory:hover:bg-coffee-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ivory:focus:ring-coffee-300 transform transition-transform duration-200 ease-in-out hover:-translate-y-0.5"
            aria-label={t('common.theme', { theme: t(`common.themes.${theme}`) })}
        >
            {theme === 'light' ? (
                // Sun Icon (Current: Light)
                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M12 5a7 7 0 100 14 7 7 0 000-14z" />
                </svg>
            ) : theme === 'dark' ? (
                // Moon Icon (Current: Dark)
                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                </svg>
            ) : (
                // Coffee Cup Icon (Current: Ivory/Coffee)
                <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l2.122 2.122a3 3 0 01-4.243 4.242M8 19h8a2 2 0 002-2V7H6v10a2 2 0 002 2zM10 3v2m4-2v2" />
                </svg>
            )}
        </button>
    );
};

export default ThemeSwitcher;
